module.exports = __webpack_public_path__ + "media/images/it/icons/rocket-393ead6c3579d329f2783e2eaa0c50c6.svg";